module.exports = __webpack_public_path__ + "img/graphic_barricade_black.811e9b40.svg";